import { inject, Injectable } from '@angular/core';
import { ViewConfig } from '../../../models/view-config.interface';
import { CarrierFoldersPaginatedService } from '@app/carrier/services/carrier-folders-paginated.service';
import { CarrierDeliveryNotesPaginatedService } from '@app/carrier/services/carrier-delivery-notes-paginated.service';
import { CarrierToursPaginatedService } from '@app/carrier/services/carrier-tours-paginated.service';
import { DeliveryNoteBundlesService, ToursService } from 'api/services';
import { CarrierViewActionsService } from '../carrier-view-actions.service';
import { AppStore } from '@app/stores/appStore';
import { TourPlanStore } from '@app/stores/tourPlanStore';

// Import individual config factories
import { CarrierFoldersConfig } from './folders-config';
import { CarrierDeliveryNotesConfig } from './deliverynotes-config';
import { CarrierToursConfig } from './tours-config';

/**
 * Carrier View Configuration Index
 * Aggregates all carrier-specific view configurations
 */
@Injectable({
    providedIn: 'root',
})
export class CarrierViewConfigService {
    private appStore = inject(AppStore);
    private tourPlanStore = inject(TourPlanStore);

    constructor(
        private carrierFoldersPaginatedService: CarrierFoldersPaginatedService,
        private carrierDeliveryNotesPaginatedService: CarrierDeliveryNotesPaginatedService,
        private carrierToursPaginatedService: CarrierToursPaginatedService,
        private deliveryNoteBundlesService: DeliveryNoteBundlesService,
        private toursService: ToursService,
        private carrierViewActionsService: CarrierViewActionsService
    ) {}

    getViewConfigs(): Map<string, ViewConfig> {
        const configs = new Map<string, ViewConfig>();

        // Folders configuration
        configs.set(
            'carrier-folders',
            CarrierFoldersConfig.create({
                carrierFoldersPaginatedService:
                    this.carrierFoldersPaginatedService,
                deliveryNoteBundlesService: this.deliveryNoteBundlesService,
                actionsService: this.carrierViewActionsService,
                appStore: this.appStore,
                tourPlanStore: this.tourPlanStore,
            })
        );

        // Tours configuration
        configs.set(
            'carrier-tours',
            CarrierToursConfig.create({
                carrierToursPaginatedService: this.carrierToursPaginatedService,
                toursService: this.toursService,
                actionsService: this.carrierViewActionsService,
                appStore: this.appStore,
            })
        );

        // Delivery Notes configuration
        configs.set(
            'carrier-deliverynotes',
            CarrierDeliveryNotesConfig.create({
                carrierDeliveryNotesPaginatedService:
                    this.carrierDeliveryNotesPaginatedService,
                actionsService: this.carrierViewActionsService,
                appStore: this.appStore,
                tourPlanStore: this.tourPlanStore,
            })
        );

        return configs;
    }
}
